import { Box, Modal, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { deleteGolfAreaById } from '../../../api/golf';
import { useToast } from 'use-toast-mui';
import { errorMessages } from '../../../utils/methods';

const GolfAreaDeleteModal = ({ open, handleClose, area, refreshSpotAreas, onDeleteSuccess }) => {
  const { t } = useTranslation();
  const user = useSelector(state => state.user.user);
  const toast = useToast();

  const handleDeleteConfirm = async () => {
    try {
      if (area && user?.token) {
        console.log('area.golfAreaId : ' + area.golfAreaId);
        try {
          await deleteGolfAreaById(user.token, area.golfAreaId);

          let updatedAreas = [];

          if (refreshSpotAreas) {
            updatedAreas = await refreshSpotAreas();
          }

          if (onDeleteSuccess) {
            onDeleteSuccess(area, updatedAreas);
          }

          handleClose();
        } catch (error) {
          toast.error(errorMessages(error));
        }
      }
    } catch (error) {
      console.error('구역 삭제 실패:', error);
    }
  };

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '465px',
    height: 'auto',
    bgcolor: 'background.paper',
    borderRadius: '16px',
    boxShadow: 24,
    p: '32px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        disableEscapeKeyDown
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={modalStyle}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Typography sx={{ fontSize: '24px', fontWeight: '600', color: '#000', mb: '24px' }}>
              {t('The spots in this area will also be deleted')}
            </Typography>
            <Typography sx={{ fontSize: '16px', fontWeight: '400', color: '#737373' }}>
              {t('If you delete the spot area, it cannot be recovered.')}
            </Typography>
            <Typography sx={{ fontSize: '16px', fontWeight: '400', color: '#737373' }}>
              {t('Please be careful when deleting')}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: '12px', mt: '8px' }}>
            <Button
              sx={{
                backgroundColor: '#D9D9D9',
                width: '120px',
                height: '48px',
                borderRadius: '16px',
                fontSize: '20px',
                color: '#000',
                '&:hover': { backgroundColor: '#D9D9D9' },
              }}
              onClick={handleClose}>
              {t('CANCEL')}
            </Button>
            <Button
              sx={{
                backgroundColor: '#EE735A',
                width: '240px',
                height: '48px',
                borderRadius: '16px',
                fontSize: '20px',
                color: '#fff',
                '&:hover': { backgroundColor: '#EE735A' },
              }}
              onClick={handleDeleteConfirm}>
              {t('DELETE')}
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default GolfAreaDeleteModal;
